<template>
    <div class="error_messages">
        <div class="ui error large message" v-show="(errors.length > 0 || error_objects.length > 0) && show">
            <i class="close icon" v-if="is_closable" @click.prevent="show = !show"></i>
            <div class="header">
                {{ description }}
            </div>
            <ul class="list" v-for="error in errors">
                <li>{{ error }}</li>
            </ul>
            <ul class="list" v-for="error_object in error_objects">
                <li>{{ error_object.name }}: {{ error_object.error }}</li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: "ToolErrorBoxMain",
    props: {
        errors: {
            default: () => [],
            type: Array,
        },
        error_objects: {
            default: () => [],
            type: Array,
        },
        description: String,
        is_closable: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            show: true,
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
        errors(val) {
            this.init()
        },
        error_objects(val) {
            this.init()
        },
    },
    methods: {
        init() {
            this.show = true
        }
    },
    components: {
    },
}
</script>

<style scoped lang="scss">
.ui.message {
    margin-bottom: 1em;
}
</style>
